import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "../../utils/utils"

// Status/score pill pattern per design-system-buildmybizbrand-v1.md Section 7:
// tint background + solid-color text reads calmer than solid-bg + white text.
const badgeVariants = cva(
  "inline-flex items-center rounded-radius-full text-xs font-bold px-2.5 py-[3px]",
  {
    variants: {
      variant: {
        success: "bg-success-tint text-success",
        warning: "bg-warning-tint text-warning",
        error: "bg-error-tint text-error",
        primary: "bg-primary-tint text-primary",
        neutral: "bg-section text-ink/60",
      },
    },
    defaultVariants: {
      variant: "neutral",
    },
  },
)

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => (
  <span ref={ref} className={cn(badgeVariants({ variant, className }))} {...props} />
))
Badge.displayName = "Badge"

export { Badge, badgeVariants }
